
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.59 3.59A2.006 2.006 0 0016.17 3H5a2 2 0 00-2 2v14a2.006 2.006 0 002 2h14a2.006 2.006 0 002-2V7.83a1.966 1.966 0 00-.59-1.41l-2.82-2.83zM12 19a3 3 0 110-6 3 3 0 010 6zm1-10H7a2 2 0 110-4h6a2 2 0 110 4z"}})])
          )
        }
      }
    